import { render, staticRenderFns } from "./SpoiledBar.vue?vue&type=template&id=6e537a76&scoped=true&"
import script from "./SpoiledBar.vue?vue&type=script&lang=js&"
export * from "./SpoiledBar.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledBar.vue?vue&type=style&index=0&id=6e537a76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e537a76",
  null
  
)

export default component.exports